var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_vm.isThemeCustomizerOpen ? _c('div', {
    staticClass: "theme-customizer-overlay",
    on: {
      "click": function ($event) {
        if ($event.target !== $event.currentTarget) return null;
        return _vm.close.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "theme-customizer-panel"
  }, [_c('div', {
    staticClass: "panel-header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t("theme_customizer.title")))]), _c('button', {
    staticClass: "close-btn",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("×")])]), _c('div', {
    staticClass: "panel-content"
  }, [_c('div', {
    staticClass: "top-row"
  }, [_c('div', {
    staticClass: "logo-upload-section"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t("theme_customizer.logo")))]), _c('div', {
    staticClass: "logo-preview"
  }, [_vm.customLogo ? _c('img', {
    staticClass: "preview-image",
    attrs: {
      "src": _vm.customLogo,
      "alt": "Custom logo"
    }
  }) : _c('div', {
    staticClass: "no-logo-text"
  }, [_vm._v(" " + _vm._s(_vm.$t("theme_customizer.no_logo")) + " ")])]), _c('input', {
    staticClass: "logo-upload-input",
    attrs: {
      "type": "file",
      "accept": "image/*",
      "id": "logo-upload"
    },
    on: {
      "change": _vm.handleLogoUpload
    }
  }), _c('label', {
    staticClass: "upload-btn",
    attrs: {
      "for": "logo-upload"
    }
  }, [_vm._v(_vm._s(_vm.$t("theme_customizer.upload_logo")))])]), _vm.fontVariable ? _c('div', {
    staticClass: "font-section"
  }, [_c('h3', [_vm._v(_vm._s(_vm.fontVariable.label))]), _c('div', {
    staticClass: "font-preview",
    style: {
      fontFamily: _vm.customTheme[_vm.fontVariable.key]
    }
  }, [_c('div', {
    staticClass: "font-preview-text"
  }, [_vm._v("Aa Bb Cc")]), _c('div', {
    staticClass: "font-preview-name"
  }, [_vm._v(" " + _vm._s(_vm.customTheme[_vm.fontVariable.key]) + " ")])]), _c('select', {
    staticClass: "font-select",
    attrs: {
      "id": _vm.fontVariable.key
    },
    domProps: {
      "value": _vm.customTheme[_vm.fontVariable.key]
    },
    on: {
      "change": function (e) {
        return _vm.handleVariableChange(_vm.fontVariable.key, e.target.value);
      }
    }
  }, _vm._l(_vm.fontVariable.options, function (option) {
    return _c('option', {
      key: option,
      domProps: {
        "value": option
      }
    }, [_vm._v(" " + _vm._s(option) + " ")]);
  }), 0)]) : _vm._e()]), _c('h3', {
    staticClass: "mt-4"
  }, [_vm._v(_vm._s(_vm.$t("theme_customizer.theme_colors")))]), _c('div', {
    staticClass: "controls-scroll"
  }, _vm._l(_vm.colorVariables, function (variable) {
    return _c('div', {
      key: variable.key,
      staticClass: "control-item"
    }, [_c('label', {
      attrs: {
        "for": variable.key
      }
    }, [_vm._v(_vm._s(variable.label))]), variable.type === 'color' ? _c('input', {
      staticClass: "control-input",
      attrs: {
        "id": variable.key,
        "type": "color"
      },
      domProps: {
        "value": _vm.getColorValue(variable.key)
      },
      on: {
        "input": function (e) {
          return _vm.handleVariableChange(variable.key, e.target.value);
        }
      }
    }) : variable.type === 'select' ? _c('select', {
      staticClass: "control-input",
      attrs: {
        "id": variable.key
      },
      domProps: {
        "value": _vm.customTheme[variable.key]
      },
      on: {
        "change": function (e) {
          return _vm.handleVariableChange(variable.key, e.target.value);
        }
      }
    }, _vm._l(variable.options, function (option) {
      return _c('option', {
        key: option,
        domProps: {
          "value": option
        }
      }, [_vm._v(" " + _vm._s(option) + " ")]);
    }), 0) : variable.type === 'text' ? _c('input', {
      staticClass: "control-input control-input-text",
      attrs: {
        "id": variable.key,
        "type": "text"
      },
      domProps: {
        "value": _vm.customTheme[variable.key]
      },
      on: {
        "input": function (e) {
          return _vm.handleVariableChange(variable.key, e.target.value);
        }
      }
    }) : _vm._e()]);
  }), 0)]), _c('div', {
    staticClass: "panel-footer"
  }, [_c('button', {
    staticClass: "btn-action",
    on: {
      "click": _vm.resetTheme
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("theme_customizer.reset")) + " ")]), _c('button', {
    staticClass: "btn-primary",
    on: {
      "click": _vm.exportTheme
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("theme_customizer.download_json")) + " ")])])])]) : _vm._e()])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }